module.exports = __webpack_public_path__ + "img/clas-ingl-03.a5666f43.jpg";